
export const FH_UI_CODESYSTEM =
  'https://fluentinhealth.com/FHIR/CodeSystem/FluentHealthUI';

export const RECORD_VALUESET_URLS = {
  CONDITION_LIST: 'https://fluentinhealth.com/FHIR/ValueSet/FACT-cn',
  SPECIALITY_LIST: 'https://fluentinhealth.com/FHIR/ValueSet/FACT-sty',
  MEDICAL_RECORD_CATEGORIES:
    'https://fluentinhealth.com/FHIR/ValueSet/DocumentType',
  TYPE_OF_VISIT_LIST: 'https://fluentinhealth.com/FHIR/ValueSet/EncounterClass',
  BOOM_MODULE: 'https://fluentinhealth.com/FHIR/ValueSet/BOOMModule',
  PARAMETER_UNITS: 'https://fluentinhealth.com/FHIR/ValueSet/ParameterUnits',
  LOINC_FHIR_URL: 'http://loinc.org?fhir_vs',
  DOCUMENT_ESCALATION_REASON: 'https://fluentinhealth.com/FHIR/ValueSet/DocumentEscalationReason',
  DOCUMENT_REJECTION_REASON: 'https://fluentinhealth.com/FHIR/ValueSet/DocumentRejectionReason',
  DOCUMENT_LEGAL_ESCALATION_REASON: 'https://fluentinhealth.com/FHIR/ValueSet/legal-escalation-reasons',
  LOINC_VALUESET_URL: 'https://fluentinhealth.com/FHIR/ValueSet/LoincCommon',
};

export const IMAGE_UPLOAD_SIZE = 5 * 1024 * 1024;

// Helper
export const NONCE_CHARACTERS =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AUDIT_LOG: any = {
  // User Management
  ADD_USER_PROFILE:
    'New user profile created: {UserName} (Roles: {AssignedRoles})',
  EDIT_USER_PROFILE: 'User profile updated for: {UserName}',
  DEACTIVATE_USER_PROFILE: 'User profile deactivated for: {UserName}',
  // Doctor Management
  ADD_DOCTOR_PROFILE: 'New doctor profile created: {DoctorName}',
  EDIT_DOCTOR_PROFILE: 'Doctor profile updated for: {DoctorName}',
  ADD_SCHEDULE: 'New schedule added for: {DoctorName}',
  MODIFY_SCHEDULE: 'Schedule updated for: {DoctorName}',
  CANCEL_APPOINTMENT: 'Appointment cancelled for: {DoctorName}',
  ADD_LEAVE: 'Leave recorded for: {DoctorName}',
  ACTIVATE_SCHEDULE: 'Schedule activated for: {DoctorName}',
  DEACTIVATE_SCHEDULE: 'Schedule deactivated for: {DoctorName}',
  // Records Management
  APPROVE_DOCUMENT: 'Document approved: {DocumentType} (ID: {DocumentID})',
  VALIDATE_DOCUMENT: 'Document validated: {DocumentType} (ID: {DocumentID})',
  ESCALATE_DOCUMENT: 'Document escalated: {DocumentType} (ID: {DocumentID})',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const permissionsFeatureCodes: any = {
  sops_view: 'sops_view', // To-Do: Add this check when View SOPs feature is add
  important_links_view: 'important_links_view', // To-Do: Add this check when View Important Links feature is add
  user_sa_pa_create: 'user_sa_pa_create',
  user_sa_pa_modify: 'user_sa_pa_modify',
  user_sa_pa_suspend: 'user_sa_pa_suspend',
  user_fa_create: 'user_fa_create',
  user_fa_modify: 'user_fa_modify',
  user_fa_suspend: 'user_fa_suspend',
  user_records_management_create: 'user_records_management_create',
  user_records_management_modify: 'user_records_management_modify',
  user_records_management_suspend: 'user_records_management_suspend',
  user_operations_create: 'user_operations_create',
  user_operations_modify: 'user_operations_modify',
  user_operations_suspend: 'user_operations_suspend',
  user_cs_create: 'user_cs_create',
  user_cs_suspend: 'user_cs_suspend',
  user_cs_modify: 'user_cs_modify',
  user_rmo_create: 'user_rmo_create',
  user_rmo_suspend: 'user_rmo_suspend',
  user_rmo_modify: 'user_rmo_modify',
  user_finance_create: 'user_finance_create',
  user_finance_modify: 'user_finance_modify',
  user_finance_suspend: 'user_finance_suspend',
  doctor_profile_create: 'doctor_profile_create',
  doctor_profile_modify: 'doctor_profile_modify',
  doctor_profile_suspend: 'doctor_profile_suspend', // To-Do: Add this check when Suspend Doctor Profile feature is add
  doctors_schedule_add: 'doctors_schedule_add', // To-Do: Add this check when Add Doctor's Schedule feature is add
  doctors_schedule_modify: 'doctors_schedule_modify', // To-Do: Add this check when Modify Doctor's Schedule feature is add
  doctors_schedule_delete: 'doctors_schedule_delete', // To-Do: Add this check when Delete Doctor's Schedule feature is add
  documents_view: 'documents_view',
  documents_modify: 'documents_modify',
  documents_approve: 'documents_approve',
  documents_reject: 'documents_reject',
  documents_escalate: 'documents_escalate',
  escalated_documents_view: 'escalated_documents_view',
  escalated_documents_modify: 'escalated_documents_modify',
  escalated_documents_approve: 'escalated_documents_approve',
  escalated_documents_reject: 'escalated_documents_reject',
  escalate_documents_to_cs: 'escalate_documents_to_cs',
  quality_check_summary: 'quality_check_summary',
  quality_check_conduct: 'quality_check_conduct',
  logs_view: 'logs_view',
  detailed_logs_view: 'detailed_logs_view',
  tickets_create: 'tickets_create', // To-Do: Add this check when Create Tickets feature is add
  tickets_manage: 'tickets_manage', // To-Do: Add this check when Manage Tickets feature is add
  settlement_reports_order_wise_view: 'settlement_reports_order_wise_view', // To-Do: Add this check when View Settlement Reports (order wise) feature is add
  order_refund: 'order_refund', // To-Do: Add this check when Refund an order feature is add
  free_appointment_create: 'free_appointment_create', // To-Do: Add this check when Create a free appointment in available slot - FOC feature is add
  doctors_schedule_view: 'doctors_schedule_view', // To-Do: Add this check when View Doctor's Schedule feature is add
  patient_appointments_view: 'patient_appointments_view', // To-Do: Add this check when View patient appointments feature is add
  patient_appointments_modify: 'patient_appointments_modify', // To-Do: Add this check when Edit patient appointments feature is add
  patient_appointments_cancel: 'patient_appointments_cancel', // To-Do: Add this check when Cancel patient appointments feature is add
  patient_appointments_manage: 'patient_appointments_manage', // To-Do: Add this check when Manage patient appointments feature is add
  settlement_reports_view: 'settlement_reports_view', // To-Do: Add this check when View overall settlement reports (Daily) feature is add
  settlement_reports_upload: 'settlement_reports_upload', // To-Do: Add this check when Upload overall settlement reports (Daily) feature is add
  settlement_reports_modify: 'settlement_reports_modify', // To-Do: Add this check when Modify overall settlement reports (Daily) feature is add
  financial_order_reports_view: 'financial_order_reports_view', // To-Do: Add this check when View financial order reports (each order) feature is add
  financial_order_reports_modify: 'financial_order_reports_modify', // To-Do: Add this check when Upload financial order reports (each order) feature is add
  financial_order_reports_upload: 'financial_order_reports_upload', // To-Do: Add this check when Modify financial order reports (each order) feature is add
  financial_order_reports_approve: 'financial_order_reports_approve', // To-Do: Add this check when Approve Uploaded Financial Order Reports feature is add
  financial_order_reports_reject: 'financial_order_reports_reject', // To-Do: Add this check when Reject Uploaded Financial Order Reports feature is add
  doctors_settlement_reports_view: 'doctors_settlement_reports_view', // To-Do: Add this check when View Doctor's settlement reports feature is add
  doctors_settlement_reports_upload: 'doctors_settlement_reports_upload', // To-Do: Add this check when Upload Doctor's settlement reports feature is add
  doctors_settlement_reports_modify: 'doctors_settlement_reports_modify', // To-Do: Add this check when Modify Doctor's settlement reports feature is add
  finance_escalations_view: 'finance_escalations_view', // To-Do: Add this check when View Finance related CS escalations feature is add
  finance_escalations_respond: 'finance_escalations_respond', // To-Do: Add this check when Respond to Finance related CS escalations feature is add
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const newPermissionsFeatureCodes: any = {
  escalate_documents_to_cs: 'escalate_documents_to_cs',
  escalated_documents_approve: 'escalated_documents_approve',
  escalated_documents_modify: 'escalated_documents_modify',
  escalated_documents_reject: 'escalated_documents_reject',
  escalated_documents_view: 'escalated_documents_view',
  logs_view: 'logs_view',
  quality_check_conduct: 'quality_check_conduct',
  quality_check_summary: 'quality_check_summary',
  reviewer_documents_approve: 'reviewer_documents_approve',
  reviewer_documents_escalate: 'reviewer_documents_escalate',
  reviewer_documents_modify: 'reviewer_documents_modify',
  reviewer_documents_reject: 'reviewer_documents_reject',
  reviewer_documents_view: 'reviewer_documents_view',
  user_fa_create: 'user_fa_create',
  user_fa_modify: 'user_fa_modify',
  user_fa_suspend: 'user_fa_suspend',
  user_records_management_create: 'user_records_management_create',
  user_records_management_modify: 'user_records_management_modify',
  user_records_management_suspend: 'user_records_management_suspend',
  user_sa_pa_create: 'user_sa_pa_create',
  user_sa_pa_modify: 'user_sa_pa_modify',
  user_sa_pa_suspend: 'user_sa_pa_suspend',
  validator_documents_approve: 'validator_documents_approve',
  validator_documents_modify: 'validator_documents_modify',
  validator_documents_reject: 'validator_documents_reject',
  validator_documents_escalate: 'validator_documents_escalate',
  validator_documents_view: 'validator_documents_view',
};


interface CheckMapping {
  [permission: string]: string[];
}
export const checkMapping: CheckMapping = {
  user_sa_pa_suspend: ['sa_admin', 'pa_admin'],
  user_fa_suspend: ['fa_doctor', 'doctor'],
  user_records_management_suspend: [
    'fa_records',
    'record_supervisor',
    'record_reviewer',
    'record_validator',
  ],
  user_operations_suspend: ['fa_operations'],
  user_cs_suspend: ['cs_admin', 'cs_supervisor', 'cs_agent'],
  user_rmo_suspend: ['rmo_admin', 'rmo_supervisor', 'rmo_agent'],
  user_finance_suspend: ['finance_manager'],
};

export const checkMappingCreate: CheckMapping = {
  user_sa_pa_create: ['sa_admin', 'pa_admin'],
  user_fa_create: ['fa_doctor', 'doctor'],
  user_records_management_create: [
    'fa_records',
    'record_supervisor',
    'record_reviewer',
    'record_validator',
  ],
  user_operations_create: ['fa_operations'],
  user_cs_create: ['cs_admin', 'cs_supervisor', 'cs_agent'],
  user_rmo_create: ['rmo_admin', 'rmo_supervisor', 'rmo_agent'],
  user_finance_create: ['finance_manager'],
};

export const taskQueryBusinessStatus: CheckMapping = {
  documentReviewBusinessStatus: [
    'document-engine:boom-reviwer:classification:timed-out',
    'document-engine:boom-reviewer:review:timed-out',
    'document-engine:boom-reviewer:classification:in-progress',
    'document-engine:boom-reviewer:review:in-progress',
  ],
  // ideal scenario for new document assigned to reviewer
  documentReviewFallbackBusinessStatus: [
    'document-engine:backend:classification:failed',
    'document-engine:backend:base-data-extraction:completed',
  ],
  documentValidatorBusinessStatus: [
    'document-engine:boom-validator:validation:in-progress',
    //Todo: Only for testing purpose, Need to remove this post backend 
    'document-engine:boom-reviewer:review:completed'
  ],
  //Validator: ideal scenario for new document assigned to validator
  documentValidatorFallbackBusinessStatus: [
    'document-engine:boom-validator:validation:timed-out',
    'document-engine:backend:ehr-extraction:completed',
  ],
  // TO-DO: Time-out is not there for Supervisor
  documentSupervisorBusinessStatus: [
    'document-engine:boom-supervisor:classification:in-progress',
    'document-engine:boom-supervisor:review:in-progress',
    'document-engine:boom-supervisor:validation:in-progress',
  ],
  documentSupervisorFallbackBusinessStatus: [
    'document-engine:boom-reviewer:classification:escalated',
    'document-engine:boom-reviewer:review:escalated',
    'document-engine:boom-validator:validation:escalated',
  ],
};

type BoomClassifierStatus = {
  started: string;
  inProgress: string;
  timedOut: string;
  completed: string;
  escalated: string;
  rejected: string;
  failed: string;
};

type BoomStatuses = {
  started: string;
  inProgress: string;
  timedOut: string;
  completed: string;
  escalated: string;
  rejected: string;
};

type BoomSupervisorStatuses = {
  processStarted: string;
  classificationStarted: string;
  classificationInProgress: string;
  classificationRejected: string;
  classificationEscalated: string;
  classificationCompleted: string;
  reviewStarted: string;
  reviewInProgress: string;
  reviewRejected: string;
  reviewEscalated: string;
  reviewCompleted: string;
  validationStarted: string;
  validationInProgress: string;
  validationRejected: string;
  validationEscalated: string;
  validationCompleted: string;
};

type BoomWorkflow = {
  workflowCompleted: string;
  boomClassification: BoomClassifierStatus;
  boomReview: BoomStatuses;
  boomValidator: BoomStatuses;
  boomSupervisor: BoomSupervisorStatuses;
};

export const boomWorkflow: BoomWorkflow = {
  workflowCompleted: "document-engine:workflow:process:completed",
  boomClassification: {
    started: 'document-engine:boom-reviewer:classification:started',
    inProgress: 'document-engine:boom-reviewer:classification:in-progress',
    timedOut: 'document-engine:boom-reviewer:classification:timed-out',
    completed: 'document-engine:boom-reviewer:classification:completed',
    escalated: 'document-engine:boom-reviewer:classification:escalated',
    rejected: 'document-engine:boom-reviewer:classification:rejected',
    failed: 'document-engine:backend:classification:failed',
  },
  boomReview: {
    started: 'document-engine:boom-reviewer:review:started',
    inProgress: 'document-engine:boom-reviewer:review:in-progress',
    timedOut: 'document-engine:boom-reviewer:review:timed-out',
    completed: 'document-engine:boom-reviewer:review:completed',
    escalated: 'document-engine:boom-reviewer:review:escalated',
    rejected: 'document-engine:boom-reviewer:review:rejected',
  },

  boomValidator: {
    started: 'document-engine:boom-validator:validation:started',
    inProgress: 'document-engine:boom-validator:validation:in-progress',
    timedOut: 'document-engine:boom-validator:validation:timed-out',
    completed: 'document-engine:boom-validator:validation:completed',
    escalated: 'document-engine:boom-validator:validation:escalated',
    rejected: 'document-engine:boom-validator:validation:rejected',
  },

  boomSupervisor: {
    processStarted: 'document-engine:boom-supervisor:process:started',
    classificationStarted:
      'document-engine:boom-supervisor:classification:started',
    classificationInProgress:
      'document-engine:boom-supervisor:classification:in-progress',
    classificationRejected:
      'document-engine:boom-supervisor:classification:rejected',
    classificationEscalated:
      'document-engine:boom-supervisor:classification:escalated',
    classificationCompleted:
      'document-engine:boom-supervisor:classification:completed',
    reviewStarted: 'document-engine:boom-supervisor:review:started',
    reviewInProgress: 'document-engine:boom-supervisor:review:in-progress',
    reviewRejected: 'document-engine:boom-supervisor:review:rejected',
    reviewEscalated: 'document-engine:boom-supervisor:review:escalated',
    reviewCompleted: 'document-engine:boom-supervisor:review:completed',
    validationStarted: 'document-engine:boom-supervisor:validation:started',
    validationInProgress:
      'document-engine:boom-supervisor:validation:in-progress',
    validationRejected: 'document-engine:boom-supervisor:validation:rejected',
    validationEscalated: 'document-engine:boom-supervisor:validation:escalated',
    validationCompleted: 'document-engine:boom-supervisor:validation:completed',
  },
};

export const diagnosticReportUUID = `urn:uuid:eebc677b-8806-4f4c-aaff-03ebdd07d877`;
export const organisationUUID = `urn:uuid:0f3b1a2c-4d8e-4f5b-8c7d-9a6e0f3b1a2c`;
export const practitionerUUID = `urn:uuid:4a451c76-090a-41f6-b337-4939e1fb1775`;


export const labResultLoinc = "102009-8"

export const EXCLUDED_STATUSES = [
  'document-engine:boom-validator:validation:in-progress',
  'document-engine:boom-reviewer:review:in-progress',
  'document-engine:boom-reviewer:classification:in-progress',
  'document-engine:boom-supervisor:classification:started',
  'document-engine:boom-supervisor:classification:in-progress',
  'document-engine:boom-reviewer:review:started',
  'document-engine:boom-reviewer:classification:started',
  'document-engine:boom-supervisor:review:in-progress',
];


export const ROLES_LIST = [ 
  {
      "value": "sa_admin",
      "label": "Super Admin"
  },
  {
      "value": "pa_admin",
      "label": "Platform Admin"
  },
  {
      "value": "fa_doctor",
      "label": "Doctor Functional Admin"
  },
  {
      "value": "doctor",
      "label": "Doctors"
  },
  {
      "value": "fa_records",
      "label": "Records Functional Admin"
  },
  {
      "value": "record_supervisor",
      "label": "Records Supervisor"
  },
  {
      "value": "record_reviewer",
      "label": "Records Reviewer"
  },
  {
      "value": "record_validator",
      "label": "Records Validator"
  },
  {
      "value": "fa_operations",
      "label": "Operations Functional Admin"
  },
  {
      "value": "cs_admin",
      "label": "CS Admin"
  },
  {
      "value": "cs_supervisor",
      "label": "CS Supervisor"
  },
  {
      "value": "cs_agent",
      "label": "CS Agent"
  },
  {
      "value": "rmo_admin",
      "label": "RMO Admin"
  },
  {
      "value": "rmo_supervisor",
      "label": "RMO Supervisor"
  },
  {
      "value": "rmo_agent",
      "label": "RMO Agent"
  },
  {
      "value": "finance_manager",
      "label": "Finance Manager"
  }
]


 